import { APIResponseType } from 'app/apiService/types';
import apiService from 'app/apiService';

export interface SummarizationInitResponse {
    dealer_id: string;
    conversation_id: string;
    status: 'success' | 'error';
    message?: string;
}

// ----------- Executive Summary API Service -----------
class SummarizationApiService {
    static ENDPOINT = 'api/v2/summarization';

    static async init(dealer_id: string): Promise<APIResponseType<SummarizationInitResponse>> {
        try {
            if (!dealer_id) {
                throw new Error('Dealer ID is required');
            }

            const response = await apiService.get<SummarizationInitResponse>(
                `${this.ENDPOINT}/init?dealer_id=${dealer_id}`,
            );

            return response;
        } catch (error) {
            console.error('Error initializing executive summary:', error);
            throw error;
        }
    }
}

export default SummarizationApiService;
